export const HEADERS = (monthly) =>
	monthly
		? ['Range', 'Delivered', 'Claim', 'Claim %']
		: ['Range', 'Lang Pair', 'Delivered', 'Claim', 'Claim %'];

export const HEADERS_CSV = (monthly) =>
	monthly
		? ['Range', 'Delivered', 'Claim', 'Claim %']
		: ['Range', 'Delivered', 'Claim', 'Claim %'];
